import { axios } from '@vyce/core/src/api';

import { ChangePasswordData, CreateUserData, StatusMessage, UserExists } from '../types';
import { Address, UpdateProfilePhotoData, User } from '../../types';
import config from '../config';

const URL = `${config.gatewayApiUrl}`;

export const createUserRequest = (data: CreateUserData, recaptcha_token: string) => {
  return axios.post(`${URL}/public/v1/users`, { ...data, recaptcha_token });
};

export const userMeRequest = () => {
  return axios.post(`${URL}/public/v1/users/me/basic`, { add_core_data: true });
};

export const getEmployeeDataRequest = () => {
  return axios.post(`${URL}/public/v1/users/me/employee`, {});
};

export const userExistsRequest = ({
  email,
  phone,
  ni_number,
  recaptcha_token,
}: {
  email?: string;
  phone?: string;
  ni_number?: string;
  recaptcha_token: string;
}) => {
  return axios.post<UserExists>(`${URL}/public/v1/users/user_is_taken`, {
    email,
    phone,
    ni_number,
    recaptcha_token,
  });
};

export const updateMeRequest = (data: Partial<User>) => {
  return axios.put<StatusMessage>(`${URL}/public/v1/users`, data);
};

export const triggerRTWCheckByUser = ({
  payload,
}: {
  payload: {
    rtw_share_code: string;
    date_of_birth: string;
  };
}) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/checkers/rtw`, payload);
};

export const updateProfilePhotoRequest = (data: UpdateProfilePhotoData) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/users/change_photo`, data);
};

export const changePhoneRequest = (phone: string) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/users/change_phone`, { phone });
};

export const changePasswordRequest = (data: ChangePasswordData) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/users/change_password`, data);
};

export const changeEmailRequest = (data: { recaptcha_token: string; email: string }) => {
  return axios.post<StatusMessage>(`${URL}/public/v1/users/change_email`, data);
};

export const changeAddressRequest = (address: Address) => {
  return axios.put<Address>(`${URL}/public/v1/users/address`, { ...address });
};

export const saveCSCSNumberRequest = (number: string) => {
  return axios.put<StatusMessage>(`${URL}/public/v1/users/save_cscs_ref_number`, {
    serial_number: number,
  });
};
